// @flow

export type PaginatorPageType = 'first' | 'previous' | 'ellipsis' | 'numeric' | 'next' | 'last'

class PaginatorPage {
  type: PaginatorPageType
  number: ?number

  constructor (type: PaginatorPageType, number: ?number) {
    this.type = type
    this.number = number
  }
}

export default class Paginator {
  totalCount: number
  pageSize: number
  noPages: number
  noAbsoluteButtons: number
  buildNumericPages: (start: number, end: number) => PaginatorPage[]

  constructor (totalCount: number, pageSize: number) {
    this.totalCount = totalCount
    this.pageSize = pageSize
    this.noPages = Math.ceil(totalCount / pageSize)
    this.noAbsoluteButtons = 7 // number of nummeric links to a page, including ellipsis, but excluding, first, previous, next and last

    // 'private' methods:
    this.buildNumericPages = function (start: number, end: number): PaginatorPage[] {
      const pages = []
      for (let i = start; i < end; i++) {
        pages.push(new PaginatorPage('numeric', i))
      }
      return pages
    }
  }

  getPages (currentPage: number = 0): PaginatorPage[] {
    currentPage = currentPage < this.noPages ? currentPage : this.noPages - 1
    const half = Math.floor(this.noAbsoluteButtons / 2)
    let pages = []
    if (this.noPages <= this.noAbsoluteButtons) {
      pages = this.buildNumericPages(0, this.noPages)
    } else if (currentPage <= half) {
      pages = this.buildNumericPages(0, this.noAbsoluteButtons - 2)
      pages.push(new PaginatorPage('ellipsis'))
      pages.push(new PaginatorPage('numeric', this.noPages - 1))
    } else if (currentPage >= this.noPages - 1 - half) {
      pages = this.buildNumericPages(this.noPages - (this.noAbsoluteButtons - 2), this.noPages)
      pages.splice(0, 0, new PaginatorPage('ellipsis')) // no unshift in ie6
      pages.splice(0, 0, new PaginatorPage('numeric', 0))
    } else {
      pages = this.buildNumericPages(currentPage - half + 2, currentPage + half - 1)
      pages.push(new PaginatorPage('ellipsis'))
      pages.push(new PaginatorPage('numeric', this.noPages - 1))
      pages.splice(0, 0, new PaginatorPage('ellipsis'))
      pages.splice(0, 0, new PaginatorPage('numeric', 0))
    }
    pages.splice(0, 0, new PaginatorPage('previous', currentPage > 0 ? currentPage - 1 : undefined))
    pages.splice(0, 0, new PaginatorPage('first', currentPage > 0 ? 0 : undefined))
    pages.push(new PaginatorPage('next', currentPage < this.noPages - 1 ? currentPage + 1 : undefined))
    pages.push(new PaginatorPage('last', currentPage < this.noPages - 1 ? this.noPages - 1 : undefined))
    return pages
  }
}



// WEBPACK FOOTER //
// ./src/pagination/paginator.js